import React, { useEffect, useState } from 'react';
import DEPART_DIC from '../constants/DepartDic';
import formatNumber from '../utils/formatNumber';
import getDiscount from '../utils/getDiscount';
import FlightsClock from '../../../shared/components/FlightsClock';
import { TbPlaneDeparture } from 'react-icons/tb';
import { MdOutlineNightlight, MdFastfood } from 'react-icons/md';
import { FaCartPlus, FaHeart, FaMapMarkerAlt, FaShare } from 'react-icons/fa';
import { BsPeopleFill } from 'react-icons/bs';
import moment from 'moment';
import { CURRENCY_MAP_ICON } from '../constants/CurrencyClasses';
import { Link } from 'react-router-dom';
import { ShareModal } from '../components/ShareModal/ShareModal';

const OneHotTourView = ({ tour, discount = [], getHotelInfo }) => {
  const ADULTS = 2; // для горящих туров расчитываем предложение на двоих взрослых
  const [isOpenModal, setOpenModal] = useState(false);
  const [tourToShare, setTourToShare] = useState(null);

  /** Формирование акций и скидок, выгодных предложений на основе изменения цен на горящий тур */

  tour.volatility = 0;

  tour.text = '';
  tour.discount = false;

  const discountTour = getDiscount(
    {
      depart: tour.departurecode,
      country: tour.countrycode,
      oper: tour.operatorcode,
      region: tour.regioncode,
      subregion: tour.subregioncode,
      hotel: tour.hotelcode,
      adult: ADULTS,
      child: 0,
      meal: tour.mealcode,
      dt: tour.flydate,
      currency: tour.currency,
    },
    discount
  );

  if (
    tour.price &&
    tour.priceold &&
    parseInt(tour.priceold) > parseInt(tour.price)
  ) {
    tour.volatility = 100 - Math.round((tour.price / tour.priceold) * 100);
  }

  if (!tour.volatility) {
  }

  if (discountTour && discountTour.active) {
    if (discountTour.proc > 0) {
      tour.price = Math.ceil((tour.price * (100 - discountTour.proc)) / 100);
      tour.hot_price = Math.ceil(
        (tour.hot_price * (100 + discountTour.proc)) / 100
      );
    } else if (discountTour.currency_discount > 0) {
      tour.price = tour.price - discountTour.currency_discount;
      if (tour.hot_price > 0) {
        tour.hot_price =
          tour.hot_price - Math.ceil(discountTour.currency_discount / 2);
      }
    }
    tour.text = discountTour.text;
    tour.discount = true;
  }

  tour.full_price = tour.price * ADULTS;

  tour.full_price_label = formatNumber(tour.full_price);
  tour.full_priceold = tour.priceold * ADULTS;
  tour.full_priceold_label = formatNumber(tour.full_priceold);

  function getInfoToShare(tour) {
    return {
      name_from: tour.departurenamefrom,
      hotel_name: tour.hotelname,
      country_name: tour.countryname,
      town_name: tour.hotelregionname,
      child: 0,
      depart_id: tour.departurecode,
      star_id: tour.hotelstars,
      hotel_image_src: tour.hotelpicture,
      dt1: tour.flydate,
      adult: 2,
      offer_id: tour.tourid,
      price: tour.full_price,
    };
  }

  function handleOfficeSave() {
    localStorage.removeItem('officeId');
    if (window.location.pathname.includes('office')) {
      const { pathname } = window.location;
      const officeId = pathname
        .substring(pathname.indexOf('/office/') + '/office/'.length)
        .replace('/', '');
      localStorage.setItem('officeId', officeId);
    }
  }

  return (
    <article className={`tour-card card-full card-hot`}>
      {tourToShare ? (
        <ShareModal
          row={tourToShare}
          open={isOpenModal}
          handleClose={() => {
            setOpenModal(false);
            setTourToShare(null);
          }}
        />
      ) : null}
      <section className="tour-card__image">
        <div
          title="Средний рейтинг отеля"
          className={`tour-card__raiting  rating--${parseInt(
            tour.hotelrating
          )}`}
        >
          {parseFloat(tour.hotelrating) > 0
            ? parseFloat(tour.hotelrating).toFixed(1)
            : ''}
        </div>
        <img
          alt={tour.hotelname}
          className="tour-card__image-item"
          onClick={() => getHotelInfo(tour.hotelcode)}
          id={tour.hotelcode}
          src={tour.hotelpicture.replace('small', 'medium')}
          loading="lazy"
        />
        <div className="icon-bar">
          <div className="social-bar">
            <FaCartPlus className="social-bar__icon" />
            <FaHeart className={`like social-bar__icon`} />
            <FaShare
              title={'Поделиться туром'}
              className="social-bar__icon"
              onClick={(e) => {
                e.preventDefault();
                setOpenModal(true);
                setTourToShare(getInfoToShare(tour));
              }}
            />
            <FaMapMarkerAlt
              className="social-bar__icon"
              id={tour.hotelcode}
              onClick={() => getHotelInfo(tour.hotelcode, 1)}
            />
          </div>
        </div>
      </section>
      <section className="tour-card__body">
        <div className="tour-hotel__title title clickable">
          <p className="hotelname" style={{ maxWidth: '90%' }}>
            <span className="hotelstars">{tour.hotelstars}*</span>{' '}
            <b style={{ fontSize: '14px' }}>
              <span
                className=""
                id={tour.hotelcode}
                onClick={() => getHotelInfo(tour.hotelcode)}
              >
                {tour.hotelname}
              </span>
            </b>
          </p>
        </div>
        <div className="countryname">
          {tour.countryname}, {tour.hotelregionname},
        </div>
        <section className="tour-card__info info">
          <section className="info__description">
            <div>
              <span style={{ color: 'cadetblue' }}>
                <TbPlaneDeparture />
              </span>{' '}
              <b>
                {DEPART_DIC[tour.departurecode].id != 99 ? 'Из' : ''}{' '}
                {DEPART_DIC[tour.departurecode].name_from}
              </b>
            </div>
            <div>
              <span style={{ color: 'darkgoldenrod' }}>
                <MdOutlineNightlight />
              </span>
              вылет {moment(tour.flydate, 'DD.MM.YYYY').format('DD.MM')} (
              <b>{tour.nights} ночей</b>)
            </div>
            <div>
              <span style={{ color: 'darkgreen' }}>
                <BsPeopleFill />
              </span>{' '}
              {ADULTS} взрослых |{' '}
              <span style={{ color: 'darkorange' }}>
                <MdFastfood />
              </span>{' '}
              {tour.meal}
            </div>
          </section>
          <section className="info__price">
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                maxWidth: '140px',
              }}
            >
              <FlightsClock tour_id={tour.tourid} />
            </div>
            <div style={{ textAlign: 'center' }}>
              {!!tour.volatility && (
                <span className="price__old">
                  {tour.full_priceold_label} {CURRENCY_MAP_ICON[tour.currency]}
                </span>
              )}
              {!!tour.volatility && (
                <span className="price__percent">-{tour.volatility} %</span>
              )}
            </div>
            <div style={{ marginTop: '10px' }}>
              <Link
                to={`https://www.geograftour.com/tours/tour-info/${tour.tourid}/`}
                className="btn__info"
                target="_blank"
                onClick={handleOfficeSave}
              >
                <span className="price">
                  {tour.full_price_label} {CURRENCY_MAP_ICON[tour.currency]}
                </span>
                цена за тур
              </Link>
            </div>
          </section>
        </section>
      </section>
    </article>
  );
};

export default OneHotTourView;
